import { packageTypes } from 'json/detetion-options'
import { detectionCategory } from 'json/lab-order'
import { getEnumeration } from 'enumeration'
export default {
  getPackageList (data) {
    data.forEach((item, index) => {
      item.index = index
    })
    return data
  },
  getDetectionPackageList (data) {
    data.forEach(item => {
      item.package_type = getEnumeration(item.packageType, packageTypes)
    })
    return data
  },
  getDetectionListByFilter (data) {
    data.forEach(item => {
      item.detection_category = getEnumeration(item.category, detectionCategory, 'value', 'key')
    })
    return data
  }
}
